// Constellation
import { Box, Checkbox, FieldSet, Heading, Label, LabeledControl, Radio } from '@zillow/constellation-10';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticState } from '../../utils/hooks';

// Types
import type { PartialFilterType } from '../../models/Types';
import { dotStyles } from '../ActiveRentals/styles';

const OffMarket = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const activeTypes = useAppSelector((state) => state.filter.activeTypes);
  const deactivatedDaysRedux = useAppSelector((state) => state.filter.deactivatedDays);
  const [inactive, setInactive] = useOptimisticState(activeTypes.inactive);
  const [deactivatedDays, setDeactivatedDays] = useOptimisticState(deactivatedDaysRedux);

  const handleToggleActiveType = () => {
    setInactive(!inactive);
    const newActiveTypeFilter = {
      ...activeTypes,
      ...{ inactive: !inactive },
    };
    onFilterChange({ activeTypes: newActiveTypeFilter });
  };

  const handleDateClick = (deactivatedDays: number | null) => {
    setInactive(true);
    setDeactivatedDays(deactivatedDays);
    const partialFilter = { deactivatedDays } as PartialFilterType;
    if (!inactive) {
      partialFilter.activeTypes = {
        ...activeTypes,
        ...{ inactive: true },
      };
    }
    onFilterChange(partialFilter);
  };

  const heading = (
    <LabeledControl
      controlId="activeType-inactive"
      label={
        <Label>
          <Heading level={4} css={{ textStyle: 'body-bold', marginLeft: '200' }}>
            <Box css={{ ...dotStyles, color: 'icon.action.disabled ' }} />
            Off Market
          </Heading>
        </Label>
      }
      control={<Checkbox checked={inactive} onChange={() => handleToggleActiveType()} />}
    />
  );

  const component = (
    <FieldSet css={{ marginLeft: '1600' }}>
      <LabeledControl
        controlId="inactiveDays-30"
        label={<Label>Within 30 days (max)</Label>}
        control={<Radio checked={inactive && deactivatedDays === 30} onChange={() => handleDateClick(30)} />}
      />
      <LabeledControl
        controlId="inactiveDays-15"
        label={<Label>Within 15 days</Label>}
        control={<Radio checked={inactive && deactivatedDays === 15} onChange={() => handleDateClick(15)} />}
      />
      <LabeledControl
        controlId="inactiveDays-7"
        label={<Label>Within 7 days</Label>}
        control={<Radio checked={inactive && deactivatedDays === 7} onChange={() => handleDateClick(7)} />}
      />
    </FieldSet>
  );

  return FilterWrapper({
    heading,
    children: component,
    useCollapse: true,
  });
};

export default OffMarket;
